export abstract class IJobMarketInfo {
    public abstract get DefaultJobBoardIds(): Promise<any[]>;
}
